import * as React from "react";

import "./subsx-free.scss";

export const SubsxFree = ({xdQaName=undefined}) => (
    <div className="subsx-free subsx-free-5rf" xd-qa-type="label" xd-qa-name={xdQaName}>
        <div className="text">
            Free
        </div>
        <img src={require("./subsx-free.png")} alt="XD+"/>
    </div>
);
